import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

// Import and register all controllers
import NavbarController from "./navbar_controller.js"
application.register("navbar", NavbarController)

import HelloController from "./hello_controller.js"
application.register("hello", HelloController)

export { application }
